/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Remove_Language_AriaInputs */

const en_knp_guide_remove_language_aria = /** @type {(inputs: Knp_Guide_Remove_Language_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove language`)
};

const fr_knp_guide_remove_language_aria = /** @type {(inputs: Knp_Guide_Remove_Language_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la langue`)
};

const de_knp_guide_remove_language_aria = /** @type {(inputs: Knp_Guide_Remove_Language_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache entfernen`)
};

const it_knp_guide_remove_language_aria = /** @type {(inputs: Knp_Guide_Remove_Language_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi lingua`)
};

const ru_knp_guide_remove_language_aria = /** @type {(inputs: Knp_Guide_Remove_Language_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить язык`)
};

const es_knp_guide_remove_language_aria = /** @type {(inputs: Knp_Guide_Remove_Language_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar idioma`)
};

const zh_cn2_knp_guide_remove_language_aria = /** @type {(inputs: Knp_Guide_Remove_Language_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除语言`)
};

const ja_knp_guide_remove_language_aria = /** @type {(inputs: Knp_Guide_Remove_Language_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語を削除`)
};

const hi_knp_guide_remove_language_aria = /** @type {(inputs: Knp_Guide_Remove_Language_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषा हटाएँ`)
};

const pt_pt2_knp_guide_remove_language_aria = /** @type {(inputs: Knp_Guide_Remove_Language_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover idioma`)
};

/**
* | output |
* | --- |
* | "Remove language" |
*
* @param {Knp_Guide_Remove_Language_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_remove_language_aria = /** @type {((inputs?: Knp_Guide_Remove_Language_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Remove_Language_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_remove_language_aria(inputs)
	if (locale === "de") return de_knp_guide_remove_language_aria(inputs)
	if (locale === "it") return it_knp_guide_remove_language_aria(inputs)
	if (locale === "ru") return ru_knp_guide_remove_language_aria(inputs)
	if (locale === "es") return es_knp_guide_remove_language_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_remove_language_aria(inputs)
	if (locale === "ja") return ja_knp_guide_remove_language_aria(inputs)
	if (locale === "hi") return hi_knp_guide_remove_language_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_remove_language_aria(inputs)
	return en_knp_guide_remove_language_aria(inputs)
});